var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Catalogs", {
    attrs: {
      title: "Статусы объявления",
      "create-text": "Новый",
      "fetch-data": _vm.fetchData,
      fields: _vm.fields,
      "route-create": "JobPostingStatusAdd",
      "route-edit": "JobPostingStatusEdit",
      "route-view": "JobPostingStatusView",
      "route-path": "/job_posting_statuses",
      "can-edit": _vm.canEditJobPostingStatuses()
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d4c48aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d4c48aa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/JobPostingStatuses/JobPostingStatuses.vue
// module id = null
// module chunks = 